<template>
  <div class="text-header">
    <h2>{{ header }}</h2>
  </div>
</template>

<script>
export default  {
  props: {
    header: String,
  }
}
</script>

<style scoped lang="scss">
  .text-header {
    width: 100%;
    flex: 1 1 auto;
    min-width: 0;
  }

  .text-header h2 {
    font-size: 20px;
    font-weight: 600;
    line-height: 120%;
    margin-bottom: 0;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media (max-width: $mobile-breakpoint) {
    .text-header {
      display: none;
    }
  }
</style>